var _defs, _path, _line, _line2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew337({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,3.05A5.64,5.64,0,0,0,2.36,8.7H13.64A5.64,5.64,0,0,0,8,3.05Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.03,
    y1: 4.59,
    x2: 11.97,
    y2: 8.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.97,
    y1: 4.59,
    x2: 4.03,
    y2: 8.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 8.7,
    width: 14,
    height: 4.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew337);
export default __webpack_public_path__ + "static/media/Symbolpack_New_337.6d316d138a917a5786eb9c4ebd7a1ac4.svg";
export { ForwardRef as ReactComponent };